/* Imports */
import {
  createApp,
  markRaw,
} from 'vue';
import { createPinia } from 'pinia';

import { sentry } from './modules/sentry.js';
import App from './App.vue';
import router from './router/router.js';

/* eslint-disable no-unused-vars */
import * as registerComponents from './modules/registerComponents.js';
import * as registerIcons from './modules/registerIcons.js';
/* eslint-enable no-unused-vars */

// Set up pinia
const pinia = createPinia();
// Make router available in the store with this.router
pinia.use(({ store }) => {
  // eslint-disable-next-line no-param-reassign
  store.router = markRaw(router);
});

const app = createApp(App);

app.use(router);
app.use(pinia);

// Initialize sentry-client
sentry(app);

app.mount('#app');
